import { render, staticRenderFns } from "./message-abstract-custom.vue?vue&type=template&id=3ed16484&scoped=true"
import script from "./message-abstract-custom.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-custom.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-abstract-custom.vue?vue&type=style&index=0&id=3ed16484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed16484",
  null
  
)

export default component.exports